import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../../config/general.config';
import { Observable } from 'rxjs';
import {
  ControlOrderPayload,
  EntryControlBase,
  EntryOrderPayload,
  FormEntry,
  FormModel,
  FormModelBase,
  FormStructure, HeaderModel
} from '../model/form.model';
import { FormControlPayload } from '../../go/model/form.model';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  private formApi = API_URL + '/forms';
  private controlsApi = this.formApi + '/controls';
  private formApiWithFormId(formId: number): string {
    return `${this.formApi}/${formId}`;
  }

  private entryIdApi(entryId: number): string {
    return this.formApi + '/entries/' + entryId;
  }


  constructor(
    private http: HttpClient
  ) { }

  getForm(id: number): Observable<FormStructure> {
    return this.http.get<FormStructure>(this.formApiWithFormId(id))
  }

  deleteForm(id: number): Observable<void> {
    return this.http.delete<void>(this.formApiWithFormId(id));
  }

  createForm(projectId: string, payload: FormModelBase): Observable<FormModel> {
    return this.http.post<FormModel>(`${this.formApi}/${projectId}`, payload);
  }

  updateForm(formId: number, payload: FormModelBase): Observable<FormModel> {
    return this.http.put<FormModel>(`${this.formApi}/${formId}`, payload)
  }

  addFormEntry(formId: number, payload: FormEntry): Observable<FormEntry> {
    return this.http.post<FormEntry>(this.formApiWithFormId(formId) + '/entries', payload);
  }

  updateFormEntry(entryId: number, payload: FormEntry): Observable<FormEntry> {
    return this.http.put<FormEntry>(this.entryIdApi(entryId), payload);
  }

  deleteFormEntry(entryId: number): Observable<void> {
    return this.http.delete<void>(this.entryIdApi(entryId));
  }

  insertDictionary(formId: number, dictionaryId: number): Observable<void> {
    return this.http.post<void>(this.formApiWithFormId(formId) + '/copy-dictionary', { dictionaryId })
  }

  setEntriesOrder(formId: number, payload: EntryOrderPayload): Observable<FormStructure> {
    return this.http.post<FormStructure>(this.formApiWithFormId(formId) + '/entries/set-order', payload);
  }

  setFailureCodes(entryId: number, codes: string[]): Observable<void> {
    return this.http.post<void>(this.entryIdApi(entryId) + '/failure-codes', codes)
  }

  addControl(payload: EntryControlBase): Observable<void> {
    return this.http.post<void>(this.controlsApi, payload)
  }

  updateControl(controlId: number, payload: FormControlPayload): Observable<void> {
    return this.http.put<void>(this.controlsApi + '/' + controlId, payload);
  }

  setControlsOrder(payload: ControlOrderPayload): Observable<FormStructure> {
    return this.http.post<FormStructure>(this.controlsApi + '/set-order', payload);
  }

  deleteControl(controlId: number): Observable<void> {
    return this.http.delete<void>(`${this.controlsApi}/${controlId}`);
  }

  setHeaders(formId: number, headers: HeaderModel[]): Observable<void> {
    return this.http.post<void>(this.formApiWithFormId(formId) + '/headers', headers);
  }

  copyForm(projectId: string, formId: number): Observable<void> {
    return this.http.post<void>(this.formApiWithFormId(formId) + '/copy/' + projectId, {})
  }
}
